<template>
  <b-overlay
    id="overlay-background"
    :show="ApiSettingloader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <validation-observer
              ref="refEmailFormObserver"
            >
              <!-- form -->
              <b-form>
                <b-row>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Sendgrid Key"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_SENDGRID_KEY')"
                        label-for="sendgrid_key"
                      >
                        <b-form-input
                          id="sendgrid-key"
                          v-model="email_setting_values.sendgrid_key"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_SENDGRID_KEY')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Mail From Address"
                      rules="required|email"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_MAIL_FROM_ADDRESS')"
                        label-for="mail-from-address"
                      >
                        <b-form-input
                          id="mail-from-address"
                          v-model="email_setting_values.mail_from_address"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_MAIL_FROM_ADDRESS')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Mail From Name"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_MAIL_FROM_NAME')"
                        label-for="mail-from-name"
                      >
                        <b-form-input
                          id="mail-from-name"
                          v-model="email_setting_values.mail_from_name"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_MAIL_FROM_NAME')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  block
                  variant="primary"
                  @click="postEmailSettingValues"
                >
                  Save
                </b-button>
              </b-form>
              <!--/ form -->
            </validation-observer>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BFormInput, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
// import axios from '@axios'
// import axiosemail from '../../libs/axiosemail'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ApiSettingloader: false,
      required,
      communication_client_id: '',
      communication_secret: '',
      email_setting_values: {
        id: '',
        sendgrid_key: '',
        mail_from_address: '',
        mail_from_name: '',
        group_id: 0,
      },
    }
  },
  watch: {
    settings: {
      handler() {
        this.communication_client_id = this.settings.client_id
        this.communication_secret = this.settings.secret
        this.getMailConfigurations()
      },
    },
    // role: {
    //   handler(selected) {
    //     this.settingsData(selected)
    //   },
    // },
  },
  methods: {
    async getMailConfigurations() {
      // const headers = {
      //   clientId: this.communication_client_id,
      //   secret: this.communication_secret,
      // }
      // await axiosemail.get('/v1/email/get-user-mail-configs', { headers }).then(settings => {
      //   if (settings.status) {
      //     this.email_setting_values.id = typeof settings.data.data === 'undefined' ? 0 : settings.data.data.id
      //     this.email_setting_values.sendgrid_key = settings.data.data.sendgrid_key
      //     this.email_setting_values.mail_from_address = settings.data.data.mail_from_address
      //     this.email_setting_values.mail_from_name = settings.data.data.mail_from_name
      //   }
      // })
    },
    mapValues() {
      // console.log('Object', Object)
      Object.keys(this.email_setting_values).forEach(element => {
        const item = this.settings.filter(word => word.key === element)
        if (item.length > 0) {
          this.email_setting_values[element] = item[0].value
        }
      })
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.ApiSettingloader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    postEmailSettingValues() {
      this.$refs.refEmailFormObserver.validate().then(success => {
        if (success) {
          // const headers = {
          //   clientId: this.communication_client_id,
          //   secret: this.communication_secret,
          // }
          this.ApiSettingloader = true
          // let url = ''
          // if (this.email_setting_values.id > 0) {
          //   url = 'v1/email/update-mail-configs'
          // } else {
          //   url = 'v1/email/save-mail-configs'
          // }
          // axiosemail.post(url,
          //   { ...this.email_setting_values }, {
          //     headers,
          //   }).then(response => {
          //   if (response.status) {
          //     this.ApiSettingloader = false
          //     this.makeSuccessToast()
          //   }
          // }).catch(error => {
          //   // if (err.response.data.message) {
          //   //   this.alertErrors.push(err.response.data.message)
          //   // }
          //   this.makeFailureToast(error)
          // })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
